import {useState} from 'react';
import styled from '@emotion/styled';
export const UploadButton = (props:any)=>{
    const onChange:any = props.onChange || function(){};
    const accept = props.accept ||'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' ;
    const label = props.label || 'Upload Button';
    return (<Wrapper>
        <span>{label}</span>
        <input onChange={onChange} type="file" accept={accept} />
    </Wrapper>)
}

const Label = (props:any) =>{
    const children = props.children || '';
    return (<label {...props}>{children}</label>)
}

const Wrapper = styled(Label)`
    
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    position: relative;
    cursor: pointer;
& > span{
    background-color: ${props => props.bg ||  'var(--green-background-color)'} ;
    color:${props => props.color || 'var(--white-color)'} ;
    width: 100%;
    padding:10px 15px;
    display: flex;
    border-radius: 5px;
}

& > input{
    visibility: hidden;
    background-color: transparent;
    width:100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top:0;
    left:0;
    cursor: pointer;
}

`